export const deleteTermsSendKey = (termsSend) => {
  for (let item of termsSend.termsGroup) {
    for (let one of item.terms) {
      // 删除无用属性
      // 判断是否属性attr
      if (one.selectedOptions[0] === 'attr') {
        delete one.eventAttrOptions
        delete one.eventDateEnd
        delete one.eventDateStart
        delete one.eventTimeRelation
      }
      // 判断是否事件event
      if (one.selectedOptions[0] === 'event') {
        if (one.eventLimitTime === true) {
          one.eventDateStart = this.evalTime(one.eventDateStart)
          one.eventDateEnd = this.evalTime(one.eventDateEnd)
        }
        one.secAttr = one.selectedOptions[2]
        for (let o of one.eventAttrOptions) {
          delete o.sources
          delete o.relationOptions
          delete o.eventAttrValueOptions
        }
        delete one.startValue
        delete one.endValue
        // delete one.relationship 限制次数的必传字段，作用是标识 到底是大于 小于还是区间等等
      } else {
        one.secAttr = one.selectedOptions[1].split('@')[0]
      }
      // 判断是否群组group/标签aud_portary
      if (one.selectedOptions[0] === 'group' || one.selectedOptions[0] === 'aud_portary') {
        delete one.eventAttrOptions
        delete one.eventDateEnd
        delete one.eventDateStart
      }
      let firAttr = one.selectedOptions[0]
      one.attr = one.selectedOptions[0] === 'wechat_open_id' ? 'attr' : one.selectedOptions[0]
      delete one.eventLimitAttr
      delete one.eventLimitTime
      delete one.eventLimitTimes
      delete one.original_id
      delete one.option
      delete one.relationOptions
      delete one.eventAttributeList
      delete one.end_time
      delete one.start_time
      delete one.attr_label
      delete one.eventTimeRelation
      delete one.selectedOptions
    }
  }
}

//高级查询前判断是否为空
export const judgeIsEmpty = (termsSend) => {
  console.log(termsSend, 'termsSend=========')
  for (let i in termsSend) {
    let item = termsSend[i]
    for (let j in item.terms) {
      if (item.terms[j].selectedOptions[0] === 'attr') {
        if (item.terms[j].selectedOptions[1] === '') {
          _g.toastMsg('error', '受众属性-具体属性不能为空')
          return false
        }
        if (item.terms[j].relationship === '') {
          _g.toastMsg('error', '请选择相对关系')
          return false
        }
      }
      // 判断客户属性是否为空
      if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not_empty') {
        if (item.terms[j].attr === 'attr') {
          // 判断是否是时间且为区间
          if (item.terms[j].selectedOptions[1].split('@')[1] === 'datePicker' || item.terms[j].selectedOptions[1].split('@')[1] === 'dateTimePicker') {
            if (item.terms[j].relationship === 'gtele') {
              if (item.terms[j].startValue === '') {
                _g.toastMsg('error', '受众属性-' + item.terms[j].attr_label + '      起始时间值不能为空')
                return false
              }
              if (item.terms[j].endValue === '' || item.terms[j].endValue === null) {
                _g.toastMsg('error', '受众属性-' + item.terms[j].attr_label + '      结束时间值不能为空')
                return false
              }
            } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
              _g.toastMsg('error', '受众属性-' + item.terms[j].attr_label + '      值不能为空')
              return false
            }
          } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
            _g.toastMsg('error', '受众属性-' + item.terms[j].attr_label + '      值不能为空')
            return false
          }
        }
      }
      // 判断群组是否为空
      if (item.terms[j].attr === 'group') {
        if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
          _g.toastMsg('error', '群组-' + item.terms[j].attr_label + '      值不能为空')
          return false
        }
      }
      // 判断客户画像标签是否为空
      if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not_empty') {
        if (item.terms[j].attr === 'aud_portary') {
          if (item.terms[j].relationship === '') {
            _g.toastMsg('error', '请选择相对关系')
            return false
          }
          if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
            _g.toastMsg('error', '客户画像-' + item.terms[j].attr_label + '      值不能为空')
            return false
          }
        }
      }
      // 判断受众身份是否为空
      if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not_empty') {

        if (item.terms[j].attr === 'wechat_open_id') {
          if (item.terms[j].relationship === '') {
            _g.toastMsg('error', '请选择相对关系')
            return false
          }
          if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
            _g.toastMsg('error', '受众身份-' + item.terms[j].attr_label + '      值不能为空')
            return false
          }
        }
      }


      // 判断客户事件是否为空
      if (item.terms[j].attr === 'event') {
        // 限制属性
        if (item.terms[j].eventLimitAttr === true) {
          for (let yi of item.terms[j].eventAttrOptions) {
            if (yi.attributeContent === '') {
              _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
              return false
            }
            if (yi.attributeRelation === '') {
              _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
              return false
            }
            if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty') {
              if (yi.attributeValue === '') {
                _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                return false
              }
            }
          }
        }
        // 限制起止时间
        if (item.terms[j].eventLimitTime === true) {
          if (!item.terms[j].eventDateStart || !item.terms[j].eventDateEnd) {
            _g.toastMsg('error', '请选择起止时间')
            return false
          }
        }

        // 限制发生次数
        if (item.terms[j].eventLimitTimes === true) {
          if (!item.terms[j].eventTimeRelation) {
            _g.toastMsg('error', '请选择发生次数相对关系')
            return false
          }
          if (item.terms[j].eventTimeRelation !== 'gtele') {
            if (item.terms[j].eventTimeRelation !== 'at_least_once' && item.terms[j].happenedTimes === undefined) {
              _g.toastMsg('error', '发生次数不能为空')
              return false
            }
          }
          if (item.terms[j].eventTimeRelation === 'gtele') {
            if (item.terms[j].happenedTimesStart === undefined ||
              item.terms[j].happenedTimesEnd === undefined) {
              _g.toastMsg('error', '发生次数区间值不能为空')
              return false
            }
          }
        }

        // 限制发生次数
        // if (item.terms[j].eventCheckbox2 === true) {
        //   if (item.terms[j].eventSearchTimesSelect === '') {
        //     _g.toastMsg('error', '请选择发生次数相对关系')
        //     return false
        //   }
        //   if (item.terms[j].eventSearchTimesSelect !== 'gtele') {
        //     if (item.terms[j].happenedTimes === '') {
        //       _g.toastMsg('error', '发生次数不能为空')
        //       return false
        //     }
        //   }
        //   if (item.terms[j].eventSearchTimesSelect === 'gtele') {
        //     if (item.terms[j].happenedTimes_from === '' || item.terms[j].happenedTimes_to === '') {
        //       _g.toastMsg('error', '发生次数区间值不能为空')
        //       return false
        //     }
        //   }
        // }
      }
      // 判断关注公众号是否为空
      if (item.terms[j].attr === 'follow_public') {
        if (item.terms[j].value === '' || item.terms[j].value === null) {
          _g.toastMsg('error', '关注公众号-' + item.terms[j].attr_label + '      值不能为空')
          return false
        }
      }
      // 判断客户身份是否为空
      if (item.terms[j].attr === 'customer_identity') {
        if (item.terms[j].relationship === '') {
          _g.toastMsg('error', '请选择相对关系')
          return false
        }
        if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
          if (item.terms[j].value === '' || item.terms[j].value === null) {
            _g.toastMsg('error', '客户身份-' + item.terms[j].attr_label + '      值不能为空')
            return false
          }
        }
      }
      // 判断关客户关键指标是否为空
      if (item.terms[j].attr === 'customer_kpi') {
        if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
          if (item.terms[j].relationship === '') {
            _g.toastMsg('error', '请选择相对关系')
            return false
          }
          if (item.terms[j].relationship !== 'gtele') {
            if (item.terms[j].value === '' || item.terms[j].value === null || typeof item.terms[j].value === 'undefined') {
              _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      值不能为空')
              return false
            }
          }
          if (item.terms[j].relationship === 'gtele') {
            console.log('item.terms[j].startValue', item.terms[j].startValue, item.terms[j].endValue)
            if (typeof item.terms[j].startValue === 'undefined' || typeof item.terms[j].endValue === 'undefined' || item.terms[j].startValue === '' || item.terms[j].endValue === null || item.terms[j].endValue === '' || item.terms[j].startValue === null) {
              _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      区间值不能为空')
              return false
            }
          }
        }
      }
      return true
    }
    return true
  }
}

// 高级查询维护的字典项
export function higherAduSearchOptions() {
  return [{
      value: 'attr',
      label: '受众属性',
      children: []
    },
    {
      value: 'event',
      label: '受众事件',
      children: []
    },
    {
      value: 'group',
      label: '受众群组',
      children: []
    },
    {
      value: 'aud_portary',
      label: '受众画像',
      children: [{
        label: '标签',
        value: 'tag@select',
        identity: 'tag'
      }]
    },
    {
      value: 'customer_kpi',
      label: '受众关键指标',
      children: [{
          label: '活跃度',
          value: 'activity@number',
          identity: 'activity'
        },
        {
          label: '7天活跃度',
          value: 'seven_activity@number',
          identity: 'seven_activity'
        },
        {
          label: '30天活跃度',
          value: 'thirty_activity@number',
          identity: 'thirty_activity'
        },
        {
          label: '价值评分',
          value: 'value_scoring@number',
          identity: 'value_scoring'
        },
        {
          label: '资料评分',
          value: 'score@number',
          identity: 'score'
        }
      ]
    },
    {
      value: 'follow_public',
      label: '关注公众号',
      children: [{
          label: '当前关注',
          value: 'follow_now@select',
          identity: 'means_integrate'
        },
        {
          label: '从未关注',
          value: 'follow_never@select',
          identity: 'follow_never'
        },
        {
          label: '取消关注',
          value: 'follow_cancel@select',
          identity: 'follow_cancel'
        }
      ]
    },
    {
      value: 'wechat_open_id',
      label: '受众身份',
      children: [{
        label: '微信openId',
        value: 'openId@input',
        identity: 'openId'
      }, ]
    }
    // ,
    // {
    //   value: 'aud_portary',
    //   label: '受众画像',
    //   children: [
    //     {
    //       label: '标签',
    //       value: 'tag@select',
    //       identity: 'tag'
    //     }
    //   ]
    // }
  ]
}

export function resetAttr(item) {
  item.attributeValue = ''
  item.attrValTimeStart = ''
  item.attrValTimeEnd = ''
  item.attributeRelation = ''
  item.attributeValueStart = ''
  item.attributeValueEnd = ''
  return item
}
